import React from "react";
import "../../styles/site-footer/footer.css";

const PoliticaPrivacidad = () => {
  return (
    <div
      className="modal fade vefrek-modal"
      id="ModalPrivacidad"
      tabIndex="-1"
      aria-labelledby="ModalPrivacidadLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <div>
              <h3 className="modal-title" id="ModalPrivacidadLabel">
                POLÍTICA DE PRIVACIDAD
              </h3>
              <div className="modal-subtitle-date">Última actualización: 18 de Junio de 2026</div>
            </div>
            <button
              type="button"
              className="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Cerrar"
            ></button>
          </div>
          <div className="modal-body">
            <div className="vefrek-modal-layout">


              {/* Columna Derecha: Contenido */}
              <div className="vefrek-modal-content-column">
                <p>
                  Gracias por utilizar Vefrek. Tu privacidad y la seguridad de tus datos personales son de suma importancia para nosotros. Esta Política de Privacidad describe cómo recopilamos, utilizamos, almacenamos y protegemos la información personal que obtenemos a través de nuestro sitio web https://vefrek.com.ar.
                </p>

                <section id="priv-1" className="vefrek-modal-section">
                  <h3>1. Datos Recopilados</h3>
                  <p>
                    Recopilamos información para proporcionar mejores servicios a nuestros usuarios. Esto incluye:
                  </p>
                  <ul>
                    <li><strong>Información provista por el usuario:</strong> Al registrar una empresa o crear un perfil, recopilamos su nombre, dirección de correo electrónico, número de teléfono, ubicación geográfica, nombre de la empresa y detalles del servicio automotor ofrecido.</li>
                    <li><strong>Información de uso y navegación:</strong> Registramos información técnica como su dirección IP, tipo de navegador, sistema operativo, páginas web visitadas antes de entrar a nuestro sitio y las acciones realizadas dentro de Vefrek para fines estadísticos y de mejora de rendimiento.</li>
                  </ul>
                </section>

                <section id="priv-2" className="vefrek-modal-section">
                  <h3>2. Autenticación con Google OAuth</h3>
                  <p>
                    Vefrek permite a los usuarios registrarse e iniciar sesión utilizando sus cuentas de Google mediante el protocolo OAuth 2.0.
                  </p>
                  <p>
                    Al utilizar esta funcionalidad, Google nos proporciona acceso a cierta información de tu perfil público:
                  </p>
                  <ul>
                    <li>Tu nombre y apellido de registro.</li>
                    <li>Tu dirección de correo electrónico principal.</li>
                    <li>Tu foto de perfil (para mostrarla en tu panel de control).</li>
                  </ul>
                  <p>
                    <strong>Uso de estos datos:</strong> Utilizamos esta información exclusivamente para crear tu cuenta de usuario, verificar tu identidad, iniciar tu sesión de manera segura y personalizar tu perfil de Vefrek. No almacenamos contraseñas de Google, y nunca compartiremos, alquilaremos ni venderemos los datos obtenidos a través de Google OAuth a terceros. Puedes revocar el acceso de Vefrek desde la configuración de tu cuenta de Google en cualquier momento.
                  </p>
                </section>

                <section id="priv-3" className="vefrek-modal-section">
                  <h3>3. Uso de Cookies</h3>
                  <p>
                    Utilizamos cookies propias y de terceros para optimizar la funcionalidad de la plataforma, recordar tus preferencias (como búsquedas recientes o ubicación compartida) y recopilar datos estadísticos anónimos sobre el rendimiento del sitio.
                  </p>
                  <p>
                    Puedes desactivar o borrar las cookies desde la configuración de tu navegador. Sin embargo, ten en cuenta que algunas funcionalidades del sitio web (como la persistencia de la sesión de usuario) podrían no operar de forma óptima.
                  </p>
                </section>

                <section id="priv-4" className="vefrek-modal-section">
                  <h3>4. Suscripción al Newsletter</h3>
                  <p>
                    Cuando decides suscribirte voluntariamente a nuestro boletín de noticias (Newsletter), recopilamos y almacenamos tu dirección de correo electrónico.
                  </p>
                  <p>
                    Utilizamos este dato únicamente para enviarte novedades de la plataforma, promociones relevantes del sector automotor y consejos útiles. Puedes solicitar la baja del boletín en cualquier momento haciendo clic en el enlace de desuscripción al final de cada correo o enviando un email a administracion@vefrek.com.ar.
                  </p>
                </section>

                <section id="priv-5" className="vefrek-modal-section">
                  <h3>5. Derechos del Usuario (Ley 25.326)</h3>
                  <p>
                    De acuerdo con la Ley N° 25.326 de Protección de Datos Personales de la República Argentina, tienes derecho a acceder, rectificar, actualizar, restringir o suprimir de forma permanente tus datos personales de nuestras bases de datos en cualquier momento.
                  </p>
                  <p>
                    Para ejercer cualquiera de estos derechos, puedes enviar una solicitud formal detallando tu requerimiento a administracion@vefrek.com.ar. Nos comprometemos a dar respuesta y procesar tu solicitud dentro de los plazos establecidos por la legislación vigente.
                  </p>
                </section>

                <section id="priv-6" className="vefrek-modal-section">
                  <h3>6. Seguridad de los Datos</h3>
                  <p>
                    Implementamos medidas de seguridad técnicas, administrativas y físicas de estándar de la industria (como certificados SSL y encriptación de datos en tránsito) para proteger tu información contra accesos no autorizados, pérdidas, alteraciones o divulgaciones.
                  </p>
                  <p>
                    Sin embargo, debes tener en cuenta que ninguna transmisión por Internet o almacenamiento electrónico es 100% seguro, por lo que no podemos garantizar la seguridad absoluta de los datos.
                  </p>
                </section>

                <section id="priv-7" className="vefrek-modal-section">
                  <h3>7. Divulgación e Intercambio de Información</h3>
                  <p>
                    No vendemos ni alquilamos tus datos personales. Compartiremos información únicamente en las siguientes situaciones excepcionales:
                  </p>
                  <ul>
                    <li>Con proveedores de servicios tecnológicos de confianza que nos asisten en el funcionamiento del sitio web (como alojamiento de servidores, correo masivo, analíticas web), quienes están obligados contractualmente a mantener la estricta confidencialidad de los datos.</li>
                    <li>Para cumplir con requerimientos legales, órdenes judiciales o procesos administrativos gubernamentales autorizados por ley.</li>
                  </ul>
                </section>

                <section id="priv-8" className="vefrek-modal-section">
                  <h3>8. Contacto y Consultas</h3>
                  <p>
                    Si tienes preguntas, inquietudes o deseas realizar alguna sugerencia respecto de nuestras prácticas de privacidad o del tratamiento de tu información, puedes ponerte en contacto con nosotros escribiéndonos a nuestro correo oficial:
                  </p>
                  <p>
                    <strong>Email:</strong> administracion@vefrek.com.ar
                  </p>
                </section>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              data-bs-dismiss="modal"
            >
              Aceptar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoliticaPrivacidad;
